/** @jsxImportSource @emotion/react */
import Link from 'next/link'
import { Button, ButtonExtendedProps, Text } from 'grommet'
import { useRouter } from 'next/router'
import { ShareRounded } from 'grommet-icons'
import { useTranslation } from 'next-i18next'

import { routes } from 'routes'
import useDeviceSize from 'hooks/useDevice'

type Props = {
  shortCode: string
  showIcon?: boolean
} & ButtonExtendedProps

export default function ViewResultsButton({ shortCode, showIcon = false, ...rest }: Props) {
  const router = useRouter()
  const { t } = useTranslation()
  const { small, fontSize } = useDeviceSize()
  return (
    <Link href={routes.group.results(shortCode, router.query)} passHref>
      <Button
        primary
        reverse
        size={small ? 'large' : 'small'}
        color="white"
        fill="horizontal"
        css={{
          textAlign: 'center',
          justifyContent: 'center',
          alignItems: 'center',
          display: 'flex',
        }}
        label={
          <Text textAlign="center" size={fontSize}>
            {t('components.plot-in-group.view-results')}
          </Text>
        }
        icon={showIcon ? <ShareRounded size="16px" /> : undefined}
        {...rest}
      />
    </Link>
  )
}
